export default __webpack_public_path__ + "static/home-background-lg-3dbaf860838b66fbf898c5eab9367f2c.jpg";